<div [ngClass]="isInvalid ? 'invalid' : ''" class = "form-container">
  <app-input-label
    [for]="for"
    [label]="label"
    [biggerFont]="biggerFont!"
    [inputContainer]="inputContainer"
    [isRequired]="isRequired"
  ></app-input-label>
  <div #inputContainer class="radio-buttons">
    <ng-content></ng-content>
  </div>
  <app-validation
    [hidden]="isValid"
    [validationMessages]="validationMessages"
  ></app-validation>
</div>
